// src/data/index.js
import { useEffect, useState } from 'react';
import gamesData from './games.json';
import categoriesData from './categories.json';
import site from './site.json';

export { site };
export const GAMES = gamesData;
export const CATEGORIES = categoriesData;
export const getGame = (id) => GAMES.find((g) => g.id === id) || null;
const ASSET_V = 2; // görseller aynı adla değişirse artırın (önbellek kırıcı)
export const gameIcon = (id) => `/img/games/icon/${id}.webp?v=${ASSET_V}`;
/** Oyun ekran görüntüsü: 'landscape' (1024×640) ya da 'portrait' (420×780) */
export const gameShot = (id, orientation = 'landscape') => `/img/screens/${id}-${orientation}.webp`;
export const categoryOf = (id) => categoriesData.find((c) => c.id === id) || null;

const contentCache = new Map();

/** Oyun içerik dosyasını (rehber, SSS, kurallar) ayrı parça olarak yükler. */
export function loadGameContent(id) {
  if (!contentCache.has(id)) {
    contentCache.set(
      id,
      import(`../content/games/${id}.json`).then((m) => m.default || m).catch(() => null)
    );
  }
  return contentCache.get(id);
}

export function useGameContent(id) {
  const [state, setState] = useState({ id, content: null, loading: true });
  useEffect(() => {
    let alive = true;
    setState({ id, content: null, loading: true });
    loadGameContent(id).then((content) => alive && setState({ id, content, loading: false }));
    return () => {
      alive = false;
    };
  }, [id]);
  return state.id === id ? state : { id, content: null, loading: true };
}
